<template>
    <v-container grid-list-md>
        <v-layout row align-center justify-center mt-4 v-if="loading">
            <tile :loading="true" color="primary"></tile>
        </v-layout>
        <form v-on:submit.prevent="update" v-if="! loading">
            <v-layout row wrap>
                <v-flex xs6 sm6 md6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.name"
                            :error-messages="errors.collect('data.name')"
                            label="Name"
                            data-vv-name="data.name"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 sm6 md6>
                    <v-text-field
                            v-validate="'required|email'"
                            v-model="data.email"
                            :error-messages="errors.collect('data.email')"
                            label="E-mail"
                            data-vv-name="data.email"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <v-btn large color="secondary" class="text--primary" type="submit">Edit Agent</v-btn>
                </v-flex>
            </v-layout>
        </form>
    </v-container>
</template>

<script>
    import { DICCIONARIO } from '../../../../diccionario';

    export default {
        props: ['id'],
        data : function() {
            return {
                data : {
                    email : '',
                    name: ''
                },
                loading: true,
                error : false,
                message_error : null,
                dictionary: DICCIONARIO
            }
        },
        created: function () {
            this.getAgent();
        },
        mounted () {
            this.$validator.localize('en', this.dictionary)
        },
        methods: {
            getAgent() {
                this.$store.dispatch('getAgent', {
                    id: this.id,
                }).then((res) => {

                    this.data = res.data;
                    this.loading = false;

                }).catch((error) => {

                });
            },
            update : function() {

                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.error_login = false;
                        this.message_error_login = '';

                        //dispatch the login and catch the response with the promise declared in vuex Authmodule
                        this.$store.dispatch('updateAgent', {
                            id: this.id,
                            data : this.data
                        }).then((res) => {

                            this.$store.dispatch('setSnackBarText', {
                                text: 'Agent update successfully.'
                            });
                            this.$store.dispatch('activeSnack')

                            this.getAgent();

                        }).catch((error) => {
                            //if incorrect we show a message
                            this.error_login = true;
                            this.message_error_login = error.data.message;
                        });
                    }
                });

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/agents/view/DataComponent.vue